import React from 'react';
import { MonacoJsonEditor } from '../../../components/MonacoJsonEditor';
import { FieldsAndOperatorsPanel } from '../engage-segments-tab/components/FieldsAndOperatorsPanel';
import styles from './EditSegment.module.css';

interface SegmentDefinitionEditorProps {
  contentsJson: string;
  onContentsChange: (value: string) => void;
  onValidationChange: (isValid: boolean) => void;
  availableFields: string[];
  isLoadingFields: boolean;
  fieldsError?: Error | null;
  isReadOnly: boolean;
}

export const SegmentDefinitionEditor: React.FC<
  SegmentDefinitionEditorProps
> = ({
  contentsJson,
  onContentsChange,
  onValidationChange,
  availableFields,
  isLoadingFields,
  fieldsError,
  isReadOnly,
}) => {
  return (
    <article className={styles.editor}>
      <header>
        <h2>Segment Definition</h2>
        <p>Define your segment using JSON conditions</p>
        <MonacoJsonEditor
          value={contentsJson}
          onChange={onContentsChange}
          height="400px"
          readOnly={isReadOnly}
          onValidationChange={onValidationChange}
          highlightPlaceholders
          validFields={availableFields}
        />
      </header>

      <footer>
        <FieldsAndOperatorsPanel
          availableFields={availableFields}
          isLoadingFields={isLoadingFields}
          fieldsError={fieldsError}
        />
      </footer>
    </article>
  );
};
